import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';
import MoisIcon from './_assets/mois.svg';
const AGENCY_LOGO_URL = {
  MOIS: getStaticCdnUrl('agency-logo-mois.png'),
  ODS: getStaticCdnUrl('agency-logo-ods.png')
} as const;
export const Agencies = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-24 w-84 shrink-0"><MoisIcon width={84} height={24} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <article className="gap-32 flex-center">{t0}<div className="relative h-20 w-106 shrink-0"><Image fill={true} src={AGENCY_LOGO_URL.ODS} alt={"\uB514\uC9C0\uD138\uC11C\uBE44\uC2A4\uAC1C\uBC29"} className="object-contain" sizes="106px" /></div></article>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};